import { render, staticRenderFns } from "./Worship.vue?vue&type=template&id=393a5587&scoped=true"
import script from "./Worship.vue?vue&type=script&lang=js"
export * from "./Worship.vue?vue&type=script&lang=js"
import style0 from "./Worship.vue?vue&type=style&index=0&id=393a5587&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393a5587",
  null
  
)

export default component.exports